import { IHipoModel } from "../interfaces/hipo/IHipoModel";
import { HipoAccionModel } from "./HipoAccionModel";

export class HipoModel implements IHipoModel{
    idHipo: number;
    idContratista?: number;
    contratista: string;
    idSede: number;
    idSedeSelected?: number;
    sede: string;
    idGbu: number;
    idGbuSelected?: number;
    gbu: string;
    idProyecto?: number;
    proyecto?: string;
    idCategoriaHipo: number;
    idCategoriaHipoSelected?: number;
    categoriaHipo: string;
    fechaEvento: Date;
    textoIdentificativo: string;
    descripcion: string;
    cliente: string;
    idTipoRegla: number;
    idTipoReglaSelected?: number;
    tipoRegla: string;
    tiempoPerdido?: boolean;
    tiempoPerdidoSelected?: number;
    nroDiasPerdidos?: number;
    idTipoEmpleado: number;
    idTipoEmpleadoSelected?: number;
    tipoEmpleado: string;
    idActoCondicion: number;
    idActoCondicionSelected?: number;
    idTipoAccidente: number;
    idTipoAccidenteSelected?: number;
    actoCondicion: string;
    enlaceRepositorio? : string;
    editable: boolean;
    totalAcciones: number;
    totalAccionesCerradas: number;

    acciones: Array<HipoAccionModel>;
    idCompania: number;
    idCompaniaSelected?: number;
    compania: string;

    constructor(){
        this.idHipo = 0;
        this.contratista = '';
        this.idSede = 0;
        this.sede = '';
        this.idGbu = 0;
        this.gbu = '';
        this.idCategoriaHipo = 0;
        this.categoriaHipo = '';
        this.fechaEvento = new Date();
        this.textoIdentificativo = '';
        this.descripcion = '';
        this.cliente = '';
        this.idTipoRegla = 0;
        this.tipoRegla = '';
        this.idTipoEmpleado = 0;
        this.tipoEmpleado = '';
        this.idActoCondicion = 0;
        this.idTipoAccidente = 0;
        this.actoCondicion = '';
        this.editable = false;
        this.totalAcciones = 0;
        this.totalAccionesCerradas = 0;

        this.acciones = new Array<HipoAccionModel>();
        this.idCompania = 0;
        this.compania= '';
    }
}